<template>
  <div class="work-order-list">
    <van-nav-bar
        title="项目信息"
        left-text="返回"
        left-arrow
        @click-left="$router.back()"
    />

    <van-cell-group class="order-list">
      <van-cell
          v-for="(item, index) in orderTypes"
          :key="index"
          :title="item.title"
          is-link
          @click="handleFunctionClick(item)"
          :border="false"
      >
        <template #icon>
          <van-icon :name="item.icon" :color="item.color || '#1989fa'" size="20" />
        </template>
      </van-cell>
    </van-cell-group>

    <div class="footer-tip">
      <van-icon name="info-o" /> 点击菜单查看详情
    </div>
  </div>
</template>
<script>
export default {
  name: "ProjectInfo",
  data(){
    return {
      // 工单类型数据，后续添加新类型只需在此数组中添加对象
      orderTypes:[
        {
          title: '项目概况',
          name: 'projectOverview'
        },
        {
          title: '入驻企业',
          name: 'tenantCompany'
        },
        {
          title: '配套设施',
          name: 'supportingFacilities'
        },
      ]
    }
  },
  methods: {
    handleFunctionClick(item) {
      this.$router.push({name: item.name});
    },
  }
}
</script>
<style scoped>
.work-order-list {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-bottom: 20px;
}

.order-list {
  margin: 15px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

::v-deep .van-nav-bar {
  padding-top: 4px;
  padding-bottom: 4px;
}

::v-deep .van-nav-bar__title {
  /* 调整字体大小 */
  font-size: 18px;
  /* 调整字体粗细 */
  font-weight: 600;
  color: #333;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

::v-deep .van-nav-bar__text {
  /* 调整字体大小 */
  font-size: 16px;
  /* 调整字体颜色 */
  color: #1890ff;
}

:deep(.van-cell) {
  height: 60px;
  font-size: 16px;
  font-weight: 500;
}

:deep(.van-cell__title) {
  display: flex;
  align-items: center;
  gap: 12px;
}

:deep(.van-cell:not(:last-child)::after) {
  left: 15px;
  right: 15px;
}

.footer-tip {
  text-align: center;
  color: #969799;
  font-size: 14px;
  margin-top: 30px;
  padding: 0 20px;
}

.footer-tip .van-icon {
  margin-right: 5px;
  vertical-align: middle;
}
</style>